import { Field, Form, Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { meterTypes } from "./meters-data";

const MeterForm = ({ meter }) => {
  const onDecomission = () => {
    // Decomission code here
  };

  const renderMeterTypes = () => {
    const meterTypeOptions = meterTypes.map(meterType => (
      <option key={meterType} value={meterType}>
        {meterType}
      </option>
    ));
    meterTypeOptions.unshift(
      <option key="blank" value="">
        Choose a meter type
      </option>
    );
    return meterTypeOptions;
  };

  return (
    <div className="bg-white pb-4 mb-4 rounded">
      <Formik initialValues={meter} enableReinitialize>
        {() => (
          <Form className="px-4 pt-4">
            <div>
              <Field
                className="input mb-2 truncate border-white"
                name="customer.customerName"
                type="text"
                disabled
              />
            </div>

            <div>
              <Field
                className="border rounded w-full text-gray-700 leading-tight py-2 px-4 mb-2 truncate border-white"
                placeholder="Meter Type"
                name="meterType"
                as="select"
                disabled
              >
                {renderMeterTypes()}
              </Field>
            </div>

            <div>
              <Field
                className="input mb-2 truncate border-white"
                placeholder="Meter ID"
                name="meterId"
                type="text"
                disabled
              />
            </div>

            <div>
              <Field
                className="input mb-2 truncate border-white"
                placeholder="Date (YYYY/MM/DD)"
                name="dateProvisioned"
                type="text"
                disabled
              />
            </div>

            <div>
              <Field
                className="input mb-2 truncate border-white"
                placeholder="Notes"
                name="notes"
                component="textarea"
                disabled
              />
            </div>

            <div className="flex justify-end">
              <div>
                <button
                  className="bg-blue-500 text-white font-bold py-2 px-4 rounded focus:bg-blue-700 focus:outline-none m-1"
                  onClick={onDecomission}
                >
                  Decomission
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

MeterForm.propTypes = {
  meter: PropTypes.object
};

export default MeterForm;
